'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createTheme;

var _createStyles = require('./createStyles');

var _createStyles2 = _interopRequireDefault(_createStyles);

var _base = require('./base');

var defaultBase = _interopRequireWildcard(_base);

var _helpers = require('./helpers');

var defaultHelpers = _interopRequireWildcard(_helpers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTheme() {
  var styleConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var helpers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultHelpers;
  var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultBase;

  var styles = (0, _createStyles2.default)(styleConfig);

  var theme = _extends({}, styles);

  for (var key in helpers) {
    if (Object.prototype.hasOwnProperty.call(helpers, key)) {
      styles[key] = helpers[key](styles, styleConfig);
    }
  }

  for (var _key in base) {
    if (Object.prototype.hasOwnProperty.call(base, _key)) {
      theme[_key] = base[_key](styles);
    }
  }

  return theme;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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